import { Link } from "react-router-dom";

type Article = {
	slug: string;
	title: string;
	category: 1 | 2 | 3;
};

const ALL_ARTICLES: Article[] = [
	// カテゴリ1: ECモール別 画像サイズ規格
	{
		slug: "qoo10-product-image-spec",
		title: "Qoo10 商品登録「画像が要件を満たしていません」正しいサイズと形式",
		category: 1,
	},
	{
		slug: "amazon-product-image-size-2026",
		title:
			"Amazon商品画像サイズ 2026年最新 1000×1000以上が必須な理由と最適設定",
		category: 1,
	},
	{
		slug: "rakuten-product-image-size-2026",
		title: "楽天市場 商品画像 推奨サイズ・形式・容量 2026年版まとめ",
		category: 1,
	},
	{
		slug: "mercari-product-image-size-1200x900",
		title: "メルカリ 商品写真 最適サイズ 1200×900 余白なしで売れる画像の作り方",
		category: 1,
	},
	{
		slug: "aupay-product-image-size-640",
		title: "au PAYマーケット 商品画像サイズ 640×640 要件一覧と注意点",
		category: 1,
	},
	{
		slug: "amazon-main-image-white-background-error",
		title:
			"「メイン画像の背景は白抜きにしてください」Amazon出品で弾かれた時の対処法",
		category: 1,
	},
	// カテゴリ2: アップロードエラー対処法
	{
		slug: "amazon-image-requirements-not-met",
		title: "Amazon「商品画像が要件を満たしていません」エラーの原因と解決策",
		category: 2,
	},
	{
		slug: "rakuten-rms-image-size-error",
		title: "楽天RMS「画像サイズが規定外です」アップロードできない時の対処法",
		category: 2,
	},
	{
		slug: "mercari-image-upload-failed",
		title:
			"メルカリ「画像をアップロードできませんでした」重い画像を出品する方法",
		category: 2,
	},
	{
		slug: "yahoo-shopping-image-file-size-error",
		title:
			"Yahoo!ショッピング 商品画像「ファイルサイズが大きすぎます」の解決方法",
		category: 2,
	},
	// カテゴリ3: 背景除去・画像加工テクニック
	{
		slug: "product-image-background-gray-solution",
		title: "商品画像の背景を白にしたいのに灰色になる — Photoshop以外の解決策",
		category: 3,
	},
	{
		slug: "removebg-free-limit-alternative-2026",
		title: "remove.bg 無料枠 使い切った 代替ツール 2026年版",
		category: 3,
	},
	{
		slug: "transparent-png-to-white-jpeg-amazon",
		title: "背景透過したのにAmazonで白背景にならない PNG→JPEG変換の落とし穴",
		category: 3,
	},
	{
		slug: "background-removal-edge-precision",
		title: "髪の毛・細い部分が消える 背景除去ツール比較 — エッジ精度で選ぶ",
		category: 3,
	},
	{
		slug: "smartphone-shadow-removal-guide",
		title: "スマホで撮った商品写真の影を消したい 白背景加工の最速手順",
		category: 3,
	},
];

interface RelatedArticlesProps {
	current: string;
}

export function RelatedArticles({ current }: RelatedArticlesProps) {
	const currentArticle = ALL_ARTICLES.find((a) => a.slug === current);
	const currentCategory = currentArticle?.category ?? 1;

	// 同カテゴリから2記事
	const sameCategory = ALL_ARTICLES.filter(
		(a) => a.slug !== current && a.category === currentCategory,
	).slice(0, 2);

	// 異カテゴリから各1記事
	const otherCategories = ([1, 2, 3] as const).filter(
		(c) => c !== currentCategory,
	);
	const crossCategory = otherCategories.flatMap((cat) =>
		ALL_ARTICLES.filter((a) => a.category === cat).slice(0, 1),
	);

	const related = [...sameCategory, ...crossCategory];

	return (
		<div className="mt-12 border-t pt-8">
			<h2 className="text-lg font-bold text-gray-800 mb-4">関連記事</h2>
			<ul className="space-y-2">
				{related.map((article) => (
					<li key={article.slug}>
						<Link
							to={`/blog/${article.slug}`}
							className="text-indigo-600 hover:underline text-sm"
						>
							{article.title}
						</Link>
					</li>
				))}
				<li>
					<Link to="/blog" className="text-indigo-600 hover:underline text-sm">
						→ EC商品画像 サイズ・規格ガイド 一覧
					</Link>
				</li>
				<li>
					<Link to="/" className="text-indigo-600 hover:underline text-sm">
						しろぬきやトップ — EC商品画像を一括で白背景リサイズ
					</Link>
				</li>
			</ul>
		</div>
	);
}
